const isDevEnvironment = () => {
    const hostname = window.location.hostname;
    return (
      hostname === 'localhost' ||
      hostname === '127.0.0.1' ||
      hostname.includes('.dev') || // For custom dev domains
      hostname.includes('.local') // For local network testing
    );
  };
  
  const logger = {
    log: (...args) => {
      if (isDevEnvironment()) {
        console.log(...args);
      }
    },
    error: (...args) => {
      if (isDevEnvironment()) {
        console.error(...args);
      }
    },
    warn: (...args) => {
      if (isDevEnvironment()) {
        console.warn(...args);
      }
    },
  };
  
  export default logger;

